import { motion } from "framer-motion"

import React from "react"

const Backdrop = ({ children, onClick, duration }) => {
    return (
        <motion.div
            className="z-50 fixed top-0 left-0 right-0 bottom-0 bg-black bg-opacity-50 backdrop-blur-sm overflow-hidden"
            onClick={onClick}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1, transition: { duration: duration } }}
            exit={{ opacity: 0, transition: { duration: duration } }}
            data-disable-swipe
        >
            {children}
        </motion.div>
    )
}

export default Backdrop
